<template>
  <div class="row">
    <div class="col">
      <p>Choose those companies you have support agreements with where you're offering calibration services.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="input-group">
        <label class="input-group-text" for="searchLocation">Partner:</label>
        <Multiselect ref="searchLocation" v-model="foundLocation" class="form-control custom-multiselect"
          placeholder="type to search" :close-on-select="true" :filter-results="false" :min-chars="1"
          :resolve-on-load="false" :delay="500" :searchable="true" :open-direction="'top'" :options="async (query) => {
            return await fetchLocations(query)
          }
            " label="firmName" value-prop="firm" @select="selectedLocation" />
        <button class="btn btn-success custom-focus" type="button" title="add" tabindex="-1" @click="add">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="col"></div>
  </div>
  <div class="row">
    <div class="col-6">
      <ul class="custom-list">
        <li v-for="item in firmPartners" :key="item.firmFirm">
          <div class="row">
            <div class="col">
              <span>{{ item.firmName }}</span>
              <span class="custom-id">#{{ item.parent }}</span>
            </div>
            <div class="col-1">
              <a href="#" class="custom-remove" @click="remove(item)">
                <i class="fas fa-times text-danger"></i>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'LocationPartners',
  components: {
    Multiselect
  },
  props: {
    firm: Object
  },
  data() {
    return {
      firm2: null,
      foundLocation: null
    }
  },
  computed: {
    ...mapState(locationStore, ['loading', 'firmPartners', 'foundLocations'])
  },
  methods: {
    ...mapActions(locationStore, ['searchPartners', 'getFirmPartners', 'saveFirmPartner', 'deleteFirmPartner', 'resetFoundLocations']),
    selected() { },
    async fetchLocations(query) {
      let search = {
        search: query,
        type: 2, // Corporate
        firm: this.firm.id
      }
      return await this.searchPartners(search)
    },
    selectedLocation() {
      this.$nextTick(() => {
        let found = this.foundLocations.find((x) => parseInt(x.firm) === parseInt(this.foundLocation))
        if (found) {
          console.log('Found Location', found)
          this.firm2 = found.firm
        }
      })
    },
    async add() {
      if (this.firm2) {
        let data = {
          firm: this.firm.id,
          firm2: this.firm2
        }
        await this.saveFirmPartner(data)
        this.firm2 = null
        this.foundLocation = null
        await this.getFirmPartners(this.firm.id)
      }
    },
    async remove(item) {
      if (!item || !item.firmFirm) {
        return
      } else if (item.parent === this.firm.id) {
        await this.deleteFirmPartner(item.firmFirm)
        await this.getFirmPartners(this.firm.id)
      } else {
        alert(`You cannot remove partner's belonging to another location.`)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-select {
  width: 140px !important;
}

.custom-list {
  list-style-type: none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  padding-left: 20px;
  margin-left: 5px;
  margin-right: 15px;
  height: 500px;

  li {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    padding: 5px;
    height: 44px;
  }
}

.custom-multiselect {
  position: relative;
  top: 0px;
}

.custom-id {
  position: absolute;
  font-size: 0.6em;
  font-style: italic;
  left: 5px;
  bottom: 0px;
}
</style>
